export class SuggestedTechnique {
  constructor(
    public technique: string,
    public email: string,
    public category = '',
    public id = '',
    public uid = ''
  ) {}
}
